export default __webpack_public_path__ + "static/media/83.0859a99b.png";